import { useCallback, useState } from "react";
import { AxiosError, AxiosResponse } from "axios";
import { ICollection } from "../../../utils/interfaces/collection.interface";
import { handleBackendError } from "../../../utils/helpers";
import { useTranslation } from "react-i18next";
import { IPaginationParams } from "../../../utils/interfaces/pagination-params.interface";
import { IResource } from "../../../utils/interfaces/resource.interface";
import { RoleList } from "../list/interface";
import RoleRepository from "../../../repositories/role-repository";
import { Role } from "../../../models/role";

export const useGetRole = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<RoleList[]>([]);
  const [totalData, setTotalData] = useState<number>(0);
  const [isOnFetchingData, setIsOnFetchingData] = useState<boolean>(false);

  const [roleData, setRoleData] = useState<Role | null>(null);
  const [isOnFetchingRoleData, setIsOnFetchingRoleData] =
    useState<boolean>(false);

  const loadData = useCallback(async (params: IPaginationParams) => {
    setIsOnFetchingData(true);

    await RoleRepository.all(params)
      .then((response: AxiosResponse<ICollection<RoleList[]>>) => {
        setData(response.data.data);
        setTotalData(response.data.meta.total);
      })
      .catch(() => {})
      .finally(() => {
        setIsOnFetchingData(false);
      });
  }, []);

  const loadRoleData = useCallback(
    async (id: string, params: any = null) => {
      setIsOnFetchingRoleData(true);

      await RoleRepository.show(id, params)
        .then((response: AxiosResponse<IResource<Role>>) => {
          setRoleData(response.data.data);
        })
        .catch((e: AxiosError) => {
          handleBackendError(e, t("notification.error.default"));
        })
        .finally(() => {
          setIsOnFetchingRoleData(false);
        });
    },
    [t]
  );

  return {
    data,
    totalData,
    loadData,
    isOnFetchingData,
    loadRoleData,
    isOnFetchingRoleData,
    roleData,
  };
};
